var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperMessageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/message-favorite"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-favorite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3337 6.6665V10.8332C18.3337 14.1665 16.667 15.8332 13.3337 15.8332H12.917C12.6587 15.8332 12.4087 15.9582 12.2503 16.1665L11.0003 17.8332C10.4503 18.5665 9.55033 18.5665 9.00033 17.8332L7.75033 16.1665C7.61699 15.9832 7.30866 15.8332 7.08366 15.8332H6.66699C3.33366 15.8332 1.66699 14.9998 1.66699 10.8332V6.6665C1.66699 3.33317 3.33366 1.6665 6.66699 1.6665H10.0003",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6661 3.85015C12.3911 3.02515 12.7161 2.00848 13.6161 1.72515C14.0828 1.58348 14.6661 1.70015 14.9995 2.14181C15.3161 1.68348 15.9161 1.58348 16.3828 1.72515C17.2828 2.00015 17.6078 3.02515 17.3328 3.85015C16.9078 5.15848 15.4161 5.83348 14.9995 5.83348C14.5828 5.83348 13.1078 5.16681 12.6661 3.85015Z",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3301 9.16667H13.3375",
    stroke: "#0C80F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.99607 9.16667H10.0036",
    stroke: "#0C80F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.66209 9.16667H6.66957",
    stroke: "#0C80F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperMessageIcon);
export default __webpack_public_path__ + "static/media/stepper-message-icon.f223145468f1ff9a595f3607938b1e16.svg";
export { ForwardRef as ReactComponent };